import * as actions from '../actions/applicationFormreferralSettings';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';

export function requestCaseReferralKeywords(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_CASE_REFERRAL_KEYWORDS )
        .map(action => ({
            url: BASE_URL ,
            category: 'requestCaseReferralKeywords',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestCaseReferralKeywords')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getCaseReferralKeywordsSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestCaseReferralKeywordsFail(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestCaseReferralKeywords')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.getCaseReferralKeywordsFail(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestCreateCaseReferralKeyword(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.CREATE_CASE_REFERRAL_KEYWORD ||
        action.type === ActionTypes.CREATE_CASE_REFERRAL_KEYWORD_AND_ADD_ANOTHER)
        .map(action => ({
            url: BASE_URL ,
            category: 'requestCreateCaseReferralKeyword',
            method: 'POST',
            send: action.payload.sendBody,
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestCreateCaseReferralKeyword')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.createCaseReferralKeywordSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestCreateCaseReferralKeywordFail(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestCreateCaseReferralKeyword')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.createCaseReferralKeywordFail(response));

    return {
        ACTION: httpResponse$
    };
}

//cycle that requests filtered policy
export function getFilteredPolicy(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_FILTERED_POLICY)
        .map(action => ({
            url: BASE_URL + 'api/Policies/LatestForms/' + action.payload.caseTypeId + '/' + action.payload.subCaseTypeId + '/' + action.payload.solicitorGroupId,
            category: 'getFilteredPolicy',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('getFilteredPolicy')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveFilteredPolicy(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

//cycle that requests app form template
export function getApplicationFormTemplate(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_APPLICATION_FORM_TEMPLATE)
        .map(action => ({
            url: BASE_URL + 'api/Policies/Forms/Template',
            category: 'getApplicationFormTemplate',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('getApplicationFormTemplate')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveApplicationFormTemplate(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

//cycle that catches failed request get filtered policy
export function receiveFailResponseFilteredPolicy(sources) {
    let httpResponse$ = sources.HTTP
        .select('getFilteredPolicy')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToReceiveFilteredPolicy(response));

    return {
        ACTION: httpResponse$
    };
}

export function getPolicies(sources) {
    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_GET_POLICIES)
        .map(action => ({
            url: BASE_URL + `api/Policies/Forms`,
            category: 'getPolicies',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('getPolicies')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveGetPolicies(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function receiveFailedResponseGetPolicies(sources) {
    let httpResponse$ = sources.HTTP
        .select('getPolicies')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToGetPolicies(response));

    return {
        ACTION: httpResponse$
    };
}

export function getQuestions(sources) {
    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_GET_QUESTIONS)
        .map(action => ({
            url: BASE_URL + 'api/policies/Questions',
            category: 'getQuestions',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('getQuestions')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveGetQuestions(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function badGetQuestions(sources) {
    let httpResponse$ = sources.HTTP
        .select('getQuestions')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.receiveBadRequestGetQuestions(response));

    return {
        ACTION: httpResponse$
    }
}

export function postNewPolicy(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_POST_POLICY)
        .map(action => ({
            url: BASE_URL + `api/Policies/Forms`,
            category: 'postNewPolicy',
            method: 'POST',
            send: action.payload,
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('postNewPolicy')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 201)
        .map(response => actions.receivePostPolicyResponse(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function receiveBadRequestPostNewPolicy(sources) {
    let httpResponse$ = sources.HTTP
        .select('postNewPolicy')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 400)
        .map(response => actions.receiveBadRequestPostPolicyResponse(response.response.body.message))

    return {
        ACTION: httpResponse$,
    };
}


export function patchPolicyQuestionsGroup(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_PATCH_POLICY_QUESTIONS_GROUP)
        .map(action => ({
            url: BASE_URL + 'api/Policies/Questions/Groups/' + action.payload.groupId,
            category: 'patchPolicyQuestionsGroup',
            method: 'PATCH',
            send: {
                groupId: action.payload.groupId,
                groupSortOrder: action.payload.weight
            },
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('patchPolicyQuestionsGroup')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receivePatchPolicyQuestionsGroup(JSON.parse(response.text)))

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function badResponsePatchPolicyQuestionsGroup(sources) {
    let httpResponse$ = sources.HTTP
        .select('patchPolicyQuestionsGroup')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status >399)
        .map(response => actions.failedToPatchPolicyQuestionsGroup(response));

    return {
        ACTION: httpResponse$
    };
}
